var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.4355,
    y: 17.9443,
    width: 43.8095,
    height: 33.7959,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0C27.6766 0 21.0063 2.02339 15.3328 5.8143C9.65934 9.60521 5.23739 14.9934 2.62617 21.2974C0.0149483 27.6015 -0.668267 34.5383 0.662923 41.2306C1.99411 47.9229 5.27992 54.0703 10.1048 58.8952C14.9297 63.7201 21.0771 67.0059 27.7694 68.3371C34.4617 69.6683 41.3985 68.985 47.7026 66.3738C54.0066 63.7626 59.3948 59.3407 63.1857 53.6672C66.9766 47.9937 69 41.3234 69 34.5C69 25.35 65.3652 16.5748 58.8952 10.1048C52.4252 3.63481 43.65 0 34.5 0ZM52.8515 36.7055L23.2801 51.4912C22.9043 51.679 22.4868 51.7676 22.0671 51.7486C21.6474 51.7296 21.2396 51.6036 20.8823 51.3826C20.525 51.1617 20.2302 50.853 20.0257 50.486C19.8213 50.119 19.7141 49.7058 19.7143 49.2857V19.7143C19.7145 19.2944 19.822 18.8815 20.0266 18.5148C20.2312 18.1482 20.5261 17.8399 20.8833 17.6192C21.2406 17.3985 21.6482 17.2727 22.0677 17.2538C22.4872 17.2349 22.9045 17.3235 23.2801 17.5112L52.8515 32.2969C53.2603 32.5018 53.604 32.8164 53.8442 33.2054C54.0844 33.5945 54.2117 34.0427 54.2117 34.5C54.2117 34.9572 54.0844 35.4055 53.8442 35.7945C53.604 36.1836 53.2603 36.4982 52.8515 36.7031",
    fill: "#DF1995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.6fa77e304589c68b4df4d543a507fa52.svg";
export { ForwardRef as ReactComponent };